/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerSubRegionService = {

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async getDefaultByRegion(CustomerRegionCode , params) {
    const requestScreenData = {
      url: "api/CustomerSubRegion",
      top: "1",
      filter: `IsDefault eq 'Y' and CustomerRegionCode eq '${CustomerRegionCode}'`,
    };

    if (params) {
      if (params.select) requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerSubRegionService };
